import React from 'react';
import ProtectedRoute from './ProtectedRoute';

const ProtectedAppShell = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

export default ProtectedAppShell;
